
import { Listbox } from "@headlessui/react";
import { ChevronsUpDown } from "lucide-react";
import { PLATFORM_META } from "@/constants/platforms";
import { useAccountStore } from "@/store/account-store";
import { cn } from "@/lib/utils";

export function AccountSwitcher() {
  const { accounts, activeAccountId, setActiveAccount } = useAccountStore();
  const active = accounts.find((acc) => acc.id === activeAccountId);

  if (!accounts.length) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/70">
        Add a social account to start promoting.
      </div>
    );
  }

  return (
    <Listbox value={activeAccountId ?? undefined} onChange={setActiveAccount}>
      <Listbox.Button className="flex w-full items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-left text-white">
        {active ? (
          <div className="flex items-center gap-3">
            <img
              src={PLATFORM_META[active.platform].logo}
              alt={active.platform}
              width={28}
              height={28}
              className="rounded-full border border-white/20 bg-white/10 p-1"
            />
            <div>
              <p className="text-sm font-medium">{active.handle}</p>
              <p className="text-xs text-white/60">
                {active.slotsUsed}/{active.slotsLimit} slots used
              </p>
            </div>
          </div>
        ) : (
          <span>Select account</span>
        )}
        <ChevronsUpDown className="h-4 w-4 text-white/60" />
      </Listbox.Button>
      <Listbox.Options className="mt-2 space-y-1 rounded-2xl border border-white/10 bg-zinc-900 p-2 text-sm shadow-xl">
        {accounts.map((account) => (
          <Listbox.Option key={account.id} value={account.id}>
            {({ active: isActive, selected }) => (
              <div
                className={cn(
                  "flex cursor-pointer items-center gap-3 rounded-xl px-3 py-2",
                  isActive || selected ? "bg-white/10" : "text-white/70"
                )}
              >
                <img
                  src={PLATFORM_META[account.platform].logo}
                  alt={account.platform}
                  width={24}
                  height={24}
                  className="rounded-full border border-white/10 bg-white/5 p-1"
                />
                <div>
                  <p className="font-medium text-white">{account.handle}</p>
                  <p className="text-xs text-white/60">
                    {account.slotsUsed}/{account.slotsLimit} slots used
                  </p>
                </div>
              </div>
            )}
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
}
